// extracted by mini-css-extract-plugin
export default {"error_container":"ErrorPage_error_container__DXSso"};